import { render, staticRenderFns } from "./done.vue?vue&type=template&id=28755dec&scoped=true&"
import script from "./done.vue?vue&type=script&lang=js&"
export * from "./done.vue?vue&type=script&lang=js&"
import style0 from "./done.vue?vue&type=style&index=0&id=28755dec&scoped=true&lang=css&"
import style1 from "./done.vue?vue&type=style&index=1&id=28755dec&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28755dec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28755dec')) {
      api.createRecord('28755dec', component.options)
    } else {
      api.reload('28755dec', component.options)
    }
    module.hot.accept("./done.vue?vue&type=template&id=28755dec&scoped=true&", function () {
      api.rerender('28755dec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/user/components/done.vue"
export default component.exports